@if (canEdit()) {
    <div class="flex gap align-items-end">
        <!-- u nového pobytu ve složce se vybírá i osoba, u editace ji drží vybraný řádek -->
        @if (personScroll() && !selected()) {
            <app-select-input
                class="flex-1"
                id="personId"
                [form]="form"
                [infiniteScroll]="personScroll()"
                [label]="prefix + 'fields.searchPerson'"
                valueKey="id"
                labelKey="surname"
                filterBy="name,surname,alias,insuranceNumber"
                [showClear]="true"
            >
                <ng-template #item let-item>
                    <div class="flex-column">
                        <span>{{ item | formatPerson }}</span>
                        @if (item.birthdate || item.insuranceNumber) {
                            <small>
                                {{ item.birthdate | date: 'd. M. y' }}
                                @if (item.birthdate && item.insuranceNumber) {
                                    &middot;
                                }
                                {{ item.insuranceNumber }}
                            </small>
                        }
                    </div>
                </ng-template>
                <ng-template #selectedItem let-item>
                    {{ item | formatPerson }}
                </ng-template>
            </app-select-input>
        }

        <app-date-input class="flex-1" id="dateFrom" [form]="form" [prefix]="prefix"></app-date-input>
        <app-date-input class="flex-1" id="dateTo" [form]="form" [prefix]="prefix" [showClear]="true"></app-date-input>
        <app-text-input class="flex-1" id="note" [form]="form" [prefix]="prefix"></app-text-input>

        @if (selected()) {
            <app-button
                [label]="prefix + 'actions.newStay'"
                icon="pi-plus"
                [text]="true"
                (clickEvent)="newStay()"
            ></app-button>
        }

        <app-save-button (clickEvent)="saveStay()"></app-save-button>
    </div>

    <div class="font-size-x-small text-secondary mb-3">
        @if (selected()) {
            <!-- v režimu celé složky není z formuláře poznat, čí pobyt se edituje -->
            @if (!personId) {
                {{ selected()!.person | formatPerson }}
            }
        } @else {
            {{ prefix + 'stay.newHint' | translate }}
        }
    </div>
}

<app-card-table
    #table
    [gridData]="store.data.getFolderPersonHistory()"
    [refreshCallback]="store.api.getFolderPersonHistory"
    [refreshCallbackFragment]="folderPersonHistoryRowFrag"
    [additionalFilter]="additionalFilters()"
    [transformItem]="rowClass"
    [columns]="columns"
    [hideCheckboxes]="true"
    [selectionMode]="'single'"
    [tableTitle]="tableTitle"
    [translatePrefix]="prefix"
    (selectionChanged)="onRowSelected($event)"
>
    <ng-template pTemplate="actions" let-item="item">
        @if (canEdit()) {
            <!-- probíhající pobyt drží osobu ve složce, smazat jde až po odebrání ze složky -->
            <app-button
                icon="pi-trash"
                [rounded]="true"
                [text]="true"
                [disabled]="item.isActive"
                [title]="deleteTooltip(item)"
                (clickEvent)="deleteStay(item)"
            ></app-button>
        }
    </ng-template>
</app-card-table>

<div #dialogFooter class="p-dialog-footer">
    <app-cancel-button label="common.close" (clickEvent)="dialogRef.close(true)"></app-cancel-button>
</div>
